export const updateSetUpEmmaStep = (stepId, isCompleted) => ({
    type: 'UPDATE_SETUP_EMMA_STEP',
    stepId,
    isCompleted,
});
export const setShowSetUpEmmaSteps = (value) => ({
    value,
    type: 'SET_SHOW_SETUP_EMMA_STEPS',
});
